import React, {Fragment} from "react";
import {Field} from "redux-form";
import {Box} from "@mui/system";
import BasicTextField from "../../../common/BasicTextField";

export default function ShopifyMetaData({required}) {

    return(
        <Fragment>
            <Box sx={{marginTop: '25px'}}>
                <Field
                    name="shop"
                    label="Shop"
                    component={BasicTextField}
                    variant={"standard"}
                    validate={required}
                />
            </Box>
        </Fragment>
    )
}